<page-toolbar [pageActions]="pageActions" title="Readme Overview"></page-toolbar>

<page-content>
  <data-table #table (edit)="onEdit($event)" (remove)="onRemove($event)" [columns]="columns" [dataProvider]="readmeService"
                  [searchAll]="true" title="Readmes">
  </data-table>
</page-content>
